import { ReceiptDate as BaseReceiptDate } from './receipt-head-info.styled.default';

export * from './receipt-head-info.styled.default';

export const ReceiptDate = BaseReceiptDate.withConfig({
  marginY: '$2',
});
